import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b012424"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"margin":"0 20px"},
  class: "rel cursor-pt",
  type: "default"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-xiaoxi",
  style: {"font-size":"14px","margin-right":"4px","display":"inline-block","vertical-align":"bottom"}
}, null, -1))
const _hoisted_3 = { style: {"font-size":"12px"} }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["onClick"]

import { computed, onMounted, ref } from 'vue'
import { bury } from '@/util/useBury'
import { useRouter } from 'vue-router'
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import { useStore } from 'vuex'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { request } from '@/config/request/interceptors'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()

const num: any = computed(() => store.state.message.num)

const upBurying = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'message'
    }
  })
  if (!store.getters.isLogin) {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        source: 'message',
        position: 'login'
      }
    })
  }
  router.push(useRtfix('Information'))
}

const token = computed(() => store.getters.token)
const getUnRead = async () => {
  if (token.value) {
    const { data } =
      await request.customer.importantNotice.selectUnReadCount()
    announceCount.value = data ?? 0
  }
}

getUnRead()
const announceCount = ref(0)

const time = setInterval(getUnRead, 5 * 60 * 1000)

const list = computed(() => [
  { label: '消息', count: num.value, route: useRtfix('Information') },
  { label: '公告', count: announceCount.value, route: '/sub/notice' }
])

const total = computed(() => num.value + announceCount.value)

const count = (n: number | string, max = 99) => {
  const num = Math.floor(Number(n))
  const count = num > max ? `${max.toString()}+` : num.toString()
  return count
}

const Format = {
  count
}


return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom",
    width: 200,
    trigger: "hover"
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('消息')), 1),
        _withDirectives(_createElementVNode("span", { class: "abs cart-num" }, _toDisplayString(Format.count(_unref(total))), 513), [
          [_vShow, _unref(total) && _unref(total) !== 0]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (v) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v.label,
            onClick: ($event: any) => (_unref(router).push(v.route)),
            class: "content-item"
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)(v.label)), 1),
            _withDirectives(_createElementVNode("span", { class: "content-badge" }, _toDisplayString(Format.count(v.count)), 513), [
              [_vShow, v.count > 0]
            ])
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})